export class SecurityScanConclusionFilters {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "_in",
            "baseName": "in",
            "type": "Array<SecurityScanConclusion>",
            "format": ""
        },
        {
            "name": "notIn",
            "baseName": "notIn",
            "type": "Array<SecurityScanConclusion>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SecurityScanConclusionFilters.attributeTypeMap;
    }
    constructor() {
    }
}
